var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 628.206,
    height: 570.887,
    viewBox: "0 0 628.206 570.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef7a90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d11c65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#519390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#24748a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7a90"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_514",
    "data-name": "Grupo 514",
    transform: "matrix(1, -0.017, 0.017, 1, 6440.464, 21182.812)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_464",
    "data-name": "Trazado 464",
    d: "M368.281,355.3H331.773a.621.621,0,0,1,0-1.241h36.509a.621.621,0,0,1,0,1.241Z",
    transform: "translate(-6279.638 -21451.729)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_465",
    "data-name": "Trazado 465",
    d: "M379.773,361.9a.6.6,0,0,1-.567-.422.634.634,0,0,1,.2-.692l19.046-15.039a1.9,1.9,0,0,0,0-2.96L379.41,327.749a.635.635,0,0,1-.113-.869.585.585,0,0,1,.839-.117L399.182,341.8a3.171,3.171,0,0,1,0,4.934l-19.047,15.039A.58.58,0,0,1,379.773,361.9Z",
    transform: "translate(-6298.909 -21441.313)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_466",
    "data-name": "Trazado 466",
    d: "M682.281,355.3H645.772a.621.621,0,0,1,0-1.241h36.509a.621.621,0,0,1,0,1.241Z",
    transform: "translate(-6405.708 -21451.729)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_467",
    "data-name": "Trazado 467",
    d: "M693.773,361.9a.6.6,0,0,1-.567-.422.634.634,0,0,1,.2-.692l19.047-15.039a1.9,1.9,0,0,0,0-2.96L693.41,327.749a.635.635,0,0,1-.113-.869.584.584,0,0,1,.839-.117L713.182,341.8a3.17,3.17,0,0,1,0,4.934l-19.046,15.039a.581.581,0,0,1-.362.127Z",
    transform: "translate(-6424.98 -21441.313)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_511",
    "data-name": "Grupo 511",
    transform: "translate(-5704.603 -21281.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_1033",
    "data-name": "Trazado 1033",
    transform: "translate(0 33.581) rotate(-9)",
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.9488525390625 308.1865234375 C 11.76442909240723 308.1865234375 7.815852165222168 306.533447265625 4.830544471740723 303.5318908691406 C 3.307506084442139 302.0005493164062 2.113544464111328 300.2021484375 1.281813740730286 298.1866149902344 C 0.4201983511447906 296.0987548828125 -0.01030164957046509 293.8740234375 0.00219835015013814 291.57421875 L 1.48954451084137 17.95857620239258 C 1.513813734054565 13.49142265319824 3.217467546463013 9.282769203186035 6.286698341369629 6.107884407043457 C 9.351506233215332 2.937576532363892 13.41135215759277 1.178230404853821 17.71835136413574 1.154038190841675 L 193.314697265625 0.1664612144231796 C 193.3440399169922 0.1663073599338531 193.3748168945312 0.1661919802427292 193.4041595458984 0.1661919802427292 C 197.5885772705078 0.1661919802427292 201.5371551513672 1.819230437278748 204.5224609375 4.820845603942871 C 206.0455017089844 6.352153301239014 207.2394714355469 8.150576591491699 208.0712432861328 10.16607666015625 C 208.9328155517578 12.25392246246338 209.3633575439453 14.47865390777588 209.3508453369141 16.77846145629883 L 207.8634643554688 290.3941040039062 C 207.8392028808594 294.8612670898438 206.1355438232422 299.0699157714844 203.0663146972656 302.2448120117188 C 200.0015106201172 305.4151611328125 195.9416656494141 307.1744689941406 191.6346588134766 307.1986999511719 L 16.0383129119873 308.186279296875 C 16.00896835327148 308.1864318847656 15.97819805145264 308.1865234375 15.9488525390625 308.1865234375 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 193.4041595458984 0.66619873046875 L 193.3174743652344 0.666473388671875 L 17.72116088867188 1.654052734375 C 13.54985046386719 1.677490234375 9.616653442382812 3.382659912109375 6.646163940429688 6.455413818359375 C 3.666854858398438 9.53729248046875 2.013076782226562 13.62350463867188 1.989501953125 17.96127319335938 L 0.502166748046875 291.5769348144531 C 0.4900054931640625 293.8100280761719 0.907806396484375 295.9696960449219 1.743972778320312 297.9958801269531 C 2.550628662109375 299.9506530761719 3.708358764648438 301.694580078125 5.185012817382812 303.1793212890625 C 8.075775146484375 306.0858154296875 11.89842224121094 307.6864929199219 15.94880676269531 307.6864929199219 L 16.03550720214844 307.6862182617188 L 191.6318511962891 306.6986999511719 C 195.8031616210938 306.6752319335938 199.7363586425781 304.9700317382812 202.7068481445312 301.8972778320312 C 205.6861572265625 298.8153686523438 207.3398895263672 294.7291870117188 207.3634643554688 290.3914184570312 L 208.8508453369141 16.77581787109375 C 208.8630065917969 14.54266357421875 208.4452056884766 12.38299560546875 207.6090393066406 10.3568115234375 C 206.8023834228516 8.402069091796875 205.6446533203125 6.658111572265625 204.16796875 5.173431396484375 C 201.2772369384766 2.266876220703125 197.4545440673828 0.66619873046875 193.4041595458984 0.66619873046875 M 193.4041748046875 -0.33380126953125 C 202.5480499267578 -0.33380126953125 209.9023284912109 7.30865478515625 209.8508453369141 16.78121948242188 L 208.3634643554688 290.3968505859375 C 208.3118133544922 299.9006958007812 200.8233489990234 307.6470031738281 191.6374664306641 307.6986999511719 L 16.04112243652344 308.6862182617188 C 6.851913452148438 308.7378845214844 -0.5494842529296875 301.0753784179688 -0.497833251953125 291.5715026855469 L 0.989501953125 17.95584106445312 C 1.041152954101562 8.451995849609375 8.5296630859375 0.705718994140625 17.71554565429688 0.654052734375 L 193.3118591308594 -0.333526611328125 C 193.3421325683594 -0.333709716796875 193.3739318847656 -0.33380126953125 193.4041748046875 -0.33380126953125 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_474",
    "data-name": "Trazado 474",
    d: "M927.708,209.11,762.926,237.454c-10.516,1.825-17.625,12.124-15.894,23.028l42.976,268.375c1.76,10.9,11.7,18.266,22.219,16.473l164.78-28.344c10.516-1.825,17.624-12.124,15.893-23.028L949.927,225.583c-1.76-10.9-11.7-18.267-22.219-16.474Zm62.952,285.233c1.529,9.622-4.744,18.711-14.024,20.319l-164.78,28.344c-9.284,1.584-18.053-4.917-19.6-14.535L749.275,260.1c-1.529-9.622,4.744-18.711,14.024-20.319l164.78-28.344c9.284-1.585,18.054,4.917,19.606,14.535Z",
    transform: "translate(-740.377 -208.841)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_479",
    "data-name": "Trazado 479",
    d: "M950.991,236.786,750.34,271.3a1.142,1.142,0,0,1-1.307-.969,1.174,1.174,0,0,1,.935-1.355l200.652-34.514a1.141,1.141,0,0,1,1.307.969A1.174,1.174,0,0,1,950.991,236.786Z",
    transform: "translate(-740.071 -204.291)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 7.954,
    cy: 8.244,
    rx: 7.954,
    ry: 8.244,
    transform: "translate(24.112 36.639)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_480",
    "data-name": "Trazado 480",
    d: "M911.641,220.11l-22.419,3.856a1.142,1.142,0,0,1-1.307-.969,1.174,1.174,0,0,1,.935-1.355l22.419-3.856a1.141,1.141,0,0,1,1.307.969A1.174,1.174,0,0,1,911.641,220.11Z",
    transform: "translate(-721.143 -207.254)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_481",
    "data-name": "Trazado 481",
    d: "M912.624,226.029,890.2,229.885a1.142,1.142,0,0,1-1.307-.969,1.174,1.174,0,0,1,.935-1.355l22.419-3.856a1.141,1.141,0,0,1,1.307.969A1.174,1.174,0,0,1,912.624,226.029Z",
    transform: "translate(-721.009 -206.202)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_482",
    "data-name": "Trazado 482",
    d: "M913.606,231.948,891.187,235.8a1.142,1.142,0,0,1-1.307-.969,1.174,1.174,0,0,1,.935-1.355l22.419-3.856a1.141,1.141,0,0,1,1.307.969A1.174,1.174,0,0,1,913.606,231.948Z",
    transform: "translate(-720.876 -205.15)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_487",
    "data-name": "Trazado 487",
    d: "M954.076,486.366a13.046,13.046,0,0,0-1.416-10.6,12.166,12.166,0,0,0-8.754-5.682l-58.329-70.641-13.6,14.8,58.1,67.733a12.632,12.632,0,0,0,10.121,13.245,12.253,12.253,0,0,0,13.883-8.855Z",
    transform: "translate(-723.314 -174.974)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_488",
    "data-name": "Trazado 488",
    d: "M903.983,417.055l-20.85,15.793a4.97,4.97,0,0,1-4.172.884,5.144,5.144,0,0,1-3.371-2.7l-11.982-23.619a15.069,15.069,0,0,1,3.144-20.558,13.88,13.88,0,0,1,19.835,3.259l18.02,18.938a5.412,5.412,0,0,1,1.455,4.148,5.347,5.347,0,0,1-2.079,3.851Z",
    transform: "translate(-724.823 -177.709)",
    fill: "#24748a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_28",
    "data-name": "Elipse 28",
    cx: 27.908,
    cy: 28.925,
    rx: 27.908,
    ry: 28.925,
    transform: "translate(111.018 134.299)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_489",
    "data-name": "Trazado 489",
    d: "M880.566,472.213a5.012,5.012,0,0,1-.864-.075L830.734,463.6a5.235,5.235,0,0,1-4.264-5.143c-.149-11.611.69-40.922,11.665-62.271,7.1-13.8,22.963-20.021,37.1-14.546s22.176,20.953,18.8,36.2a478.228,478.228,0,0,0-8.411,49.71,5.179,5.179,0,0,1-5.059,4.669Z",
    transform: "translate(-729.517 -178.489)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_490",
    "data-name": "Trazado 490",
    d: "M786.546,378.817a12.817,12.817,0,0,1,.272,1.931l48.812,29.185,11.864-7.079,12.648,17.161-19.828,14.647a8.836,8.836,0,0,1-10.906-.275l-50.334-41.155a11.653,11.653,0,0,1-13.138-3.478,12.72,12.72,0,0,1-1.51-13.966,11.818,11.818,0,0,1,12.069-6.406,12.1,12.1,0,0,1,10.051,9.433Z",
    transform: "translate(-738.165 -180.333)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_491",
    "data-name": "Trazado 491",
    d: "M827.522,404.285a5.284,5.284,0,0,1,2.513-3.563l22.4-12.981a13.869,13.869,0,0,1,19.925,2.6,15.08,15.08,0,0,1-2.51,20.651l-17.859,19.221a5,5,0,0,1-7.731-.439l-15.776-21.191A5.442,5.442,0,0,1,827.522,404.285Z",
    transform: "translate(-729.386 -177.602)",
    fill: "#24748a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_492",
    "data-name": "Trazado 492",
    d: "M683.6,478.091H669.67l-3.279-55.51,17.213-.18Z",
    transform: "translate(-609.098 75.052)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_493",
    "data-name": "Trazado 493",
    d: "M815.226,693.235l-44.918,0v-.589c0-10.008,7.828-18.121,17.484-18.121h27.435Z",
    transform: "translate(-737.17 -126.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_494",
    "data-name": "Trazado 494",
    d: "M801,478.091H787.072l-6.627-55.69H801Z",
    transform: "translate(-593.554 75.052)",
    fill: "#faf8f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_495",
    "data-name": "Trazado 495",
    d: "M932.225,693.235l-44.918,0v-.589c0-10.008,7.828-18.121,17.484-18.121h27.435Z",
    transform: "translate(-721.224 -126.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_496",
    "data-name": "Trazado 496",
    d: "M926.4,690.911a5.155,5.155,0,0,1-4.833-3.549L877.172,555.9a2.869,2.869,0,0,0-2.248-1.937,2.794,2.794,0,0,0-2.707,1.143l-43.3,59.842a4.232,4.232,0,0,0-.7,1.572l-13.8,63.807a5.177,5.177,0,0,1-4.757,4.135l-16.527.778a4.96,4.96,0,0,1-3.858-1.557,5.415,5.415,0,0,1-1.481-4.007l2.882-58.239a139.819,139.819,0,0,1,13.753-54.14A314.19,314.19,0,0,0,835.26,446.963l.035-.652,50.851,8.385,7.634,10.955A150.6,150.6,0,0,0,904.83,479.8c9.722,10.925,12.64,25.535,13.377,35.868A308.844,308.844,0,0,0,923.4,553.46L948.619,681.9a5.46,5.46,0,0,1-.687,4.32,5.094,5.094,0,0,1-3.589,2.309l-17.288,2.337A4.867,4.867,0,0,1,926.4,690.911Z",
    transform: "translate(-734.787 -166.645)",
    fill: "#221e1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_497",
    "data-name": "Trazado 497",
    d: "M891.159,335.836a132.178,132.178,0,0,1-4.891-21.37c-.326-4.224.718-8.768,3.686-11.683,5.554-5.454,14.991-2.856,20.8,2.305,8.395,7.46,12.581,18.924,14.164,30.267s.886,22.877,1.267,34.331,1.961,23.231,7.6,33.092,16.089,17.431,27.117,16.592a18.754,18.754,0,0,0,11.947-5.247A14.67,14.67,0,0,0,977,401.657c5.637,10.461,2.78,24.638-5.628,32.862s-21.34,10.548-32.392,7.037-20.15-12.315-25.583-22.89-7.425-22.792-7.136-34.77c.222-9.2,1.73-18.471.23-27.54s-6.976-18.276-15.611-20.412Z",
    transform: "translate(-721.373 -192.687)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_498",
    "data-name": "Trazado 498",
    d: "M859.279,345.5c-1.472,5.1-7.1,8.24-12.169,7.378s-9.232-5.186-10.771-10.262a21.816,21.816,0,0,1,1.593-15.487,23.571,23.571,0,0,1,13.314-12.291,18.558,18.558,0,0,1,17.373,2.877,6.524,6.524,0,0,1,4.465-4.839,11.8,11.8,0,0,1,6.7.1,27.686,27.686,0,0,1,15.365,11.585,47.577,47.577,0,0,1,6.964,18.6c1.714,9.973,1.082,20.871-4.323,29.312s-16.461,13.425-25.431,9.4c-.56-2.964.766-5.948,2.3-8.516s3.35-5.07,3.939-8.027-.54-6.575-3.3-7.542c-2.355-.825-4.865.512-7.346.673a7.96,7.96,0,0,1-7.2-3.7,8.6,8.6,0,0,1-.517-8.318Z",
    transform: "translate(-728.272 -190.432)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_513",
    "data-name": "Grupo 513",
    transform: "translate(-6071.755 -21179.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_462",
    "data-name": "Trazado 462",
    d: "M223.328,222.062h-87.98a10.38,10.38,0,0,0-10.175,10.545V375.9a10.38,10.38,0,0,0,10.175,10.545h87.98A10.38,10.38,0,0,0,233.5,375.9V232.607A10.38,10.38,0,0,0,223.328,222.062ZM232.306,375.9a9.157,9.157,0,0,1-8.978,9.3h-87.98a9.157,9.157,0,0,1-8.978-9.3V232.607a9.157,9.157,0,0,1,8.978-9.3h87.98a9.157,9.157,0,0,1,8.978,9.3Z",
    transform: "translate(-125.174 -222.062)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_483",
    "data-name": "Trazado 483",
    d: "M241.811,337.251H177.017c-4.054,0-7.339-2.362-7.343-5.273V284.835c0-2.911,3.29-5.269,7.343-5.273h64.794c4.054,0,7.339,2.362,7.343,5.273v47.143C249.15,334.889,245.865,337.248,241.811,337.251Z",
    transform: "translate(-155.25 -244.244)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_484",
    "data-name": "Trazado 484",
    d: "M216.558,419.57h-38.9a7.759,7.759,0,0,1,0-15.508h38.9a7.759,7.759,0,0,1,0,15.508Zm-38.9-14.267a6.517,6.517,0,0,0,0,13.026h38.9a6.517,6.517,0,0,0,0-13.026Z",
    transform: "translate(-143.241 -291.166)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_501",
    "data-name": "Trazado 501",
    d: "M688.526,363.75v.364H629.184v-.381l.319-.468,18.813-27.528a.921.921,0,0,1,1.525,0L662.457,354.2l8.98-13.025a.921.921,0,0,1,1.522,0l15.248,22.113Z",
    transform: "translate(-602.252 -272.797)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_29",
    "data-name": "Elipse 29",
    cx: 8.357,
    cy: 8.661,
    rx: 8.357,
    ry: 8.661,
    transform: "translate(22.144 46.806)",
    fill: "#ef7a90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_512",
    "data-name": "Grupo 512",
    transform: "translate(-5883.228 -21179.547)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_463",
    "data-name": "Trazado 463",
    d: "M538.328,386.444h-87.98A10.376,10.376,0,0,1,440.174,375.9V232.607a10.377,10.377,0,0,1,10.175-10.545h87.98A10.377,10.377,0,0,1,548.5,232.607V375.9A10.377,10.377,0,0,1,538.328,386.444ZM450.349,223.3a9.156,9.156,0,0,0-8.978,9.3V375.9a9.156,9.156,0,0,0,8.978,9.3h87.98a9.156,9.156,0,0,0,8.977-9.3V232.607a9.156,9.156,0,0,0-8.977-9.3Z",
    transform: "translate(-440.174 -222.062)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_471",
    "data-name": "Trazado 471",
    d: "M532.058,358.57h-38.9a7.759,7.759,0,0,1,0-15.508h38.9a7.759,7.759,0,0,1,0,15.508Zm-38.9-14.267a6.517,6.517,0,0,0,0,13.027h38.9a6.517,6.517,0,0,0,0-13.027Z",
    transform: "translate(-458.442 -234.198)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_472",
    "data-name": "Trazado 472",
    d: "M532.058,396.57h-38.9a7.759,7.759,0,0,1,0-15.508h38.9a7.759,7.759,0,0,1,0,15.508Zm-38.9-14.267a6.517,6.517,0,0,0,0,13.027h38.9a6.517,6.517,0,0,0,0-13.027Z",
    transform: "translate(-458.442 -248.626)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_433",
    "data-name": "Trazado 433",
    d: "M724.11,602.973H674.729a7.766,7.766,0,0,1-7.615-7.892V558.729a7.767,7.767,0,0,1,7.615-7.893H724.11a7.766,7.766,0,0,1,7.615,7.893v36.352a7.765,7.765,0,0,1-7.615,7.892Z",
    transform: "translate(-645.419 -514.368)",
    fill: "#ef7a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_436",
    "data-name": "Trazado 436",
    d: "M731.681,591.489H718.759a3.829,3.829,0,0,1,0-7.653h12.922a3.829,3.829,0,0,1,0,7.653Z",
    transform: "translate(-671.242 -531.583)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_437",
    "data-name": "Trazado 437",
    d: "M730.458,618.489H702.306a3.829,3.829,0,0,1,0-7.653h28.152a3.829,3.829,0,0,1,0,7.653Z",
    transform: "translate(-662.382 -545.669)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.1857c3d22b220049b7ccc69620fa555a.svg";
export { ForwardRef as ReactComponent };